export default __webpack_public_path__ + "static/media/header.c7818927.png";